import { Icon } from '@zopauk/react-components';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

interface CardIconProps {
  icon: {
    variant: IconDefinition;
    color: string;
  };
}

export const CardIcon = ({ icon }: CardIconProps) => (icon ? <Icon {...icon} size="2x" /> : null);
